var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selector-wrapper"},_vm._l((_vm.level),function(num){return _c('Selector',{key:num,staticClass:"selector-wrapper__selector",attrs:{"value":_vm.value[`cate${num}`],"optionList":_vm.list[`cate${num}`]},on:{"input":function($event){return _vm.cateInput($event, num)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }